export interface TableCellProps {
  value: string | number;
  colspan?: number;
  rowspan?: number;
  styles?: TableCellStyle[];
  border?: TableCellBorder;
}

export type Table = TableCellProps[][];

export type ImageFormat = 'png' | 'jpeg' | 'gif';

export interface TableImage {
  imgData: string;
  format: ImageFormat;
  width: number;
  height: number;
}

export enum TableCellStyle {
  Header = 'header',
  Centered = 'centered',
  Bold = 'bold',
  Body = 'body',
  Hint = 'hint'
}

export enum TableCellBorder {
  NoBorder = 'no-border'
  // PrimaryLeft = 'primary-left'
}
